// src/components/Footer.jsx
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer-boda">
      <p className="mensaje-footer">
        Gracias por acompañarnos en este momento tan especial
      </p>
      <p className="mensaje-secundario">
        Martín & July, 2025
      </p>
    </footer>
  );
}
